import { FlagsComponentRouter } from 'flags'

import OffComponent from './flag.off/index'
import OnComponent from './flag.on/index'

const FlagToggler = FlagsComponentRouter({
  flagSubscriptions: ['feature_learn-individual-resource-print-controls'],
  OnComponent,
  OffComponent,
})

export default FlagToggler
